export default {
	htmlEl: document.documentElement,
	bodyEl: document.body,
	bp: {
		md: 640,
		lg: 1025,
		xl: 1440
	}
}
